import {Backdrop} from './Backdrop';
import {MessageBox} from './MessageBox';

export class GameOverMessage {
  private message;
  private backdrop;

  constructor(scene, gameWidth, gameHeight, isForPrizes) {
    this.backdrop = new Backdrop(scene);

    let messagesConfig = [{
          xPos: 250,
          yPos: 250,
          text: "Game Over",
          fontSize: '35px',
          fontStyle: 'bold',
          center: "1",
          color: "#OOO"
        },{
        xPos: 250,
        yPos: 325,
        text: "Please try again.",
        center: "1",
        fontSize: '25px',
        color: "#OOO"
      },{
          xPos: 250,
          yPos: 500,
          text: "Uncover 3 or more words to win a prize.\nFor details on prize levels go to Settings\non the game board or the Home Page\nnavigation bar. ",
          center: "1",
          fontSize: '25px',
          color: "#OOO"
      }];

    if (!isForPrizes) {
      messagesConfig.push({
        xPos: 250,
        yPos: 390,
        text: "Win up to $5000 in the Play for Prizes mode.",
        center: "1",
        fontSize: '25px',
        color: "#OOO"

      })
    }

    this.message = new MessageBox(
      scene,
      gameWidth * 0.8,
      gameHeight * 0.6,
      messagesConfig,
      [
        {name: 'play-prizes', method: this.quit, width: 300, height: 70, x: 300, y: 620},
        {name: 'play-fun', method: this.replay, width: 300, height: 70, x: 300, y: 710}

      ],
      [
        {width: 500, height: 160, name: 'branding', x: 0.5, y: 0.2},


      ],
      null,
      'resultsbackground'
    );
  }

  public quit = () => {
    this.backdrop.destroy();
    this.message.destroy();
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.exit();
    } else {
      window._po_gm.end();
    }
  };

  public replay = () => {
    this.backdrop.destroy();
    this.message.destroy();
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.fun = true;
      // @ts-ignore
      PblInterface.game.replay();
    } else {
      window._po_gm.replay();

    }
    // window.location.reload();
  };
}
